import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import MarketOffersListModule from "../comp/mrkt-offers-list";

export default function Courses() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewSectionName data={'Medical'}/>
            <MarketOffersListModule data={"medical"}/>

          </>
        }
      />
      

    </>
  )
}